/* global axios */
import ApiClient from './ApiClient';

class WahaAPI extends ApiClient {
  constructor() {
    super('waha', { accountScoped: true });
  }

  getStatus(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/status`
    );
  }

  getSettings(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/settings`
    );
  }

  refreshQr(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/refresh_qr`
    );
  }

  requestPairingCode(accountId, inboxId, phoneNumber) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/request_pairing_code`,
      { phone_number: phoneNumber }
    );
  }

  start(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/start`
    );
  }

  stop(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/stop`
    );
  }

  reconnect(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/reconnect`
    );
  }

  disconnect(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/disconnect`
    );
  }

  reconfigureApp(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/reconfigure_app`
    );
  }

  updateChatwootAppSettings(accountId, inboxId, settings) {
    return axios.patch(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/settings/chatwoot_app`,
      { chatwoot_app: settings }
    );
  }

  updateSessionSettings(accountId, inboxId, settings) {
    return axios.patch(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/settings/session`,
      { session: settings }
    );
  }

  updateWebhookSettings(accountId, inboxId, settings) {
    return axios.patch(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/settings/webhook`,
      { webhook: settings }
    );
  }

  pullMessages(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/pull_messages`
    );
  }

  pullContacts(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/pull_contacts`
    );
  }

  pullChats(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/waha/${inboxId}/pull_chats`
    );
  }
}

export default new WahaAPI();
